import LanguageActionsEnums from './LanguageActionsEnums'
import LanguageEnum from '../../enums/LanguageEnum';
import T from 'i18n-react';
// Utils
import { getCookie, setCookie } from '../../utils/CookieUtils';

const defaultState = {
    isLoading: false,
    language:  getDefaultLanguage()
};

function getDefaultLanguage() {
    if (document.cookie && document.cookie.indexOf('marketPayLanguage=') >= 0) {
        const language = getCookie('marketPayLanguage');
        return LanguageEnum[language]
    }

    let navigatorLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
    // language would be something like es-ES or es_ES
    // However we store our files with format es.json or en.json
    // therefore retrieve only the first 2 digits
    if (navigatorLanguage.length > 2) {
        navigatorLanguage = navigatorLanguage.split("-")[0];
        navigatorLanguage = navigatorLanguage.split("_")[0];
    }
    return LanguageEnum[navigatorLanguage]
}

function LanguageReduceurs(state = defaultState, action) {
    switch (action.type) {
        case LanguageActionsEnums.LANGUAGE_SET:
            const newState = {...state};
            newState.isLoading = false;
            newState.language = LanguageEnum[action.language];
            T.setTexts(require('../../resources/i18n/' + action.language + '.json'));
            setCookie({name: 'marketPayLanguage', value: action.language});
            return newState;
        default:
            return state;
    }
}

export default LanguageReduceurs


// WEBPACK FOOTER //
// ./src/store/language/LanguageReduceurs.js